<template>
    <div :key="iteration" class="form-group form-group-selectr">
        <label for="account_id">Scheme</label>

        <select id="account_id" class="form-control" name="account_id" v-model="value">
            <option v-for="option in options" :value="option.id" v-html="option.value"></option>
        </select>
    </div>
</template>

<script>
    import VisibleSelectorWidget from './VisibleSelectorWidget.vue';

    export default {
        extends: VisibleSelectorWidget,
        created() {
            this.render();
        },
        methods: {
            broadcast(value) {
                window.events.emit('updateAccountId', parseInt(value));
            }
        }
    }
</script>
